
export function linkFinder(rels) {
    rels = (rels instanceof Array) && rels || [rels]

    return (link) => {
        return rels.find((r) => r == link.rel) != null
    }
}

export function relFinder(links) {
    return (rel) => {
        return links.find((l) => l.rel == rel) != null
    }
}

export function relFilter(links) {
    return (rel) => {
        return links.find((l) => l.rel == rel) != null
    }
}


// WEBPACK FOOTER //
// ./lib/core/links.js